import ReactPaginate from "react-paginate";
import CommonCard from "../../components/ui/CommonCard/CommonCard";
import classes from "./Risk.module.css";
import { useEffect, useRef, useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import useWindowDimensions from "../../hooks/getWindowDimensions";
import { RxCaretDown } from "react-icons/rx";
import { env } from "../../constants/env";
import axios from "axios";
import { formatDate } from "../../utilities/functions";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import CommonButton from "../../components/ui/CommonButton/CommonButton";
import AlertDialog from "../../components/ui/AlertDialog/AlertDialog";
import VerticalDotsIcon from "../../icons/VerticalDotsIcon";
import OutlinedButton from "../../components/ui/OutlinedButton/OutlinedButton";
import TableHeader from "../../components/ui/TableHeader/TableHeader";
import TableRow from "../../components/ui/TableRows/TableRows";
import TableRows from "../../components/ui/TableRows/TableRows";
import Table from "../../components/Table/Table";
import FilterIcon from "../../icons/FilterIcon";

const users = [
  {
    groupID: "1",
    flagsCount: "2",
    riskScore: "Low",
    status: "Restricted",
  },
  {
    groupID: "2",
    flagsCount: "6",
    riskScore: "High",
    status: "Restricted",
  },
  {
    groupID: "2",
    flagsCount: "3",
    riskScore: "High",
    status: "Restricted",
  },
  {
    groupID: "4",
    flagsCount: "2",
    riskScore: "Low",
    status: "Restricted",
  },
  {
    groupID: "5",
    flagsCount: "2",
    riskScore: "Low",
    status: "Restricted",
  },
  {
    groupID: "6",
    flagsCount: "2",
    riskScore: "Low",
    status: "Restricted",
  },
  {
    groupID: "7",
    flagsCount: "2",
    riskScore: "Low",
    status: "Restricted",
  },
  {
    groupID: "8",
    flagsCount: "2",
    riskScore: "Low",
    status: "Restricted",
  },
  {
    groupID: "9",
    flagsCount: "2",
    riskScore: "Low",
    status: "Restricted",
  },
  {
    groupID: "10",
    flagsCount: "2",
    riskScore: "Low",
    status: "Restricted",
  },
];

const UsersHeader = ({ width }) => {
  return (
    <tr>
      <th>Group ID</th>
      <th>Flags Count</th>
      <th>Risk Score</th>
      <th>Status</th>
      <th></th>
    </tr>
  );
};


const challenge = [
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Failed",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "2",
    status: "Ongoing",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Failed",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Ongoing",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Ongoing",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Failed",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Ongoing",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Failed",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Failed",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Failed",
  },
  {
    user: "Jane Doe",
    startDate: "2024-11-24",
    stage: "1",
    status: "Failed",
  },
  
]

const funded = [
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "No",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Restricted",
    groupTrading: "High",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Failed",
    groupTrading: "Moderate",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "Low",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "No",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "No",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "No",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "No",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "No",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "No",
  },
  {
    user: "Jane Doe",
    accountID: "123456",
    status: "Active",
    groupTrading: "No",
  }
]

const groupData = [
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  },
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  },
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  },
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  },
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  },
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  },
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  },
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  },
  {
    name: "John Doe",
    accountID: "123456",
    symbol: "GBPUSD",
    ticket: "Sell",
    direction: "USD 100.00",
    volume: "4.05",
    entry: "2024-11-18 17:43:58",
    exit: "2024-11-18 17:43:58",

  }

]

const UsersRow = ({
  user,
  deleteUser,
  suspendUser,
  reinstateUser,
  cancelUser,
}) => {
  const [showActions, setShowActions] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [action, setAction] = useState("");
  const [confirmAction, setConfirmAction] = useState("");

  console.log("USERS", user.subscription?.planId);

  const handleAction = (action) => {
    setShowActions(false);
    setShowDialog(true);
    setAction(action);
  };

  const handleConfirm = () => {
    if (action === "delete") {
      deleteUser(user._id);
    } else if (action === "suspend") {
      suspendUser(user._id);
    } else if (action === "cancel") {
      cancelUser(user._id);
    }
    setShowDialog(false);
    setConfirmAction(action);
  };

  const handleReinstate = async () => {
    await reinstateUser(user._id);
    setShowActions(false);
  };
  return (
    <>
      <TableRow
        row={[
          { className: classes.groupIdText, content: user.groupId },
          { className: "", content: user.flagsCount },
          {
            className:
              user.riskScore === "High" ? classes.highRisk : classes.lowRisk,
            content: user.riskScore,
          },
          { className: "", content: user.status },
          // {
          //   className: classes.actionWrapper,
          //   content: (
             
          //   ),
          // },
        ]}
      />
      <AlertDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        centerCard={true}
      >
        <div className={classes.cancelContainer}>
          <h5>
            {action === "suspend"
              ? "SUSPEND USER"
              : action === "cancel"
              ? "CANCEL SUBSCRIPTION"
              : "DELETE USER"}
          </h5>
          {action === "suspend" ? (
            <p>
              Are you sure you can to suspend{" "}
              <span>
                {user?.firstName} {user?.lastName}'s
              </span>{" "}
              account? The user will be unable to access the portal until this
              is undone.
            </p>
          ) : action === "cancel" ? (
            <p>
              Are you sure you can to cancel{" "}
              <span>
                {user?.firstName} {user?.lastName}'s{" "}
                {user.subscription?.planId?.planName}
              </span>{" "}
              subscription?
            </p>
          ) : (
            <p>
              Are you sure you can to delete{" "}
              <span>
                {user?.firstName} {user?.lastName}'s
              </span>{" "}
              account? The user will no longer have access to the portal.
            </p>
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          <OutlinedButton
            buttonText="Cancel"
            onClick={() => setShowDialog(false)}
          />
          <CommonButton title="Confirm" onClick={handleConfirm} />
        </div>
      </AlertDialog>
    </>
  );
};

const ChallengeRow = ({
  user,
  deleteUser,
  suspendUser,
  reinstateUser,
  cancelUser,
}) => {
  const [showActions, setShowActions] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [action, setAction] = useState("");
  const [confirmAction, setConfirmAction] = useState("");

  console.log("USERS", user.subscription?.planId);

  const handleAction = (action) => {
    setShowActions(false);
    setShowDialog(true);
    setAction(action);
  };

  const handleConfirm = () => {
    if (action === "delete") {
      deleteUser(user._id);
    } else if (action === "suspend") {
      suspendUser(user._id);
    } else if (action === "cancel") {
      cancelUser(user._id);
    }
    setShowDialog(false);
    setConfirmAction(action);
  };

  const handleReinstate = async () => {
    await reinstateUser(user._id);
    setShowActions(false);
  };
  return (
    <>
      <tr>
        <td className={classes.groupIdText}>{user.groupId}</td>
        <td>{user.flagsCount}</td>
        <td
          className={
            user.riskScore === "High" ? classes.highRisk : classes.lowRisk
          }
        >
          {user.riskScore}
        </td>
        <td>{user.status}</td>
        <td>
          <div className={classes.actionWrapper}>
            <div
              className={`d-flex align-items-center justify-content-between ${classes.cancelActionWrapper}`}
            >
              <VerticalDotsIcon onClick={() => {}} />
            </div>
          </div>
        </td>
      </tr>
      <AlertDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        centerCard={true}
      >
        <div className={classes.cancelContainer}>
          <h5>
            {action === "suspend"
              ? "SUSPEND USER"
              : action === "cancel"
              ? "CANCEL SUBSCRIPTION"
              : "DELETE USER"}
          </h5>
          {action === "suspend" ? (
            <p>
              Are you sure you can to suspend{" "}
              <span>
                {user?.firstName} {user?.lastName}'s
              </span>{" "}
              account? The user will be unable to access the portal until this
              is undone.
            </p>
          ) : action === "cancel" ? (
            <p>
              Are you sure you can to cancel{" "}
              <span>
                {user?.firstName} {user?.lastName}'s{" "}
                {user.subscription?.planId?.planName}
              </span>{" "}
              subscription?
            </p>
          ) : (
            <p>
              Are you sure you can to delete{" "}
              <span>
                {user?.firstName} {user?.lastName}'s
              </span>{" "}
              account? The user will no longer have access to the portal.
            </p>
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          <OutlinedButton
            buttonText="Cancel"
            onClick={() => setShowDialog(false)}
          />
          <CommonButton title="Confirm" onClick={handleConfirm} />
        </div>
      </AlertDialog>
    </>
  );
};



const renderAction = (row, rowIndex) => (
  <div
    className="d-flex align-items-center justify-content-between"
    style={{ cursor: "pointer" }}
  >
    <VerticalDotsIcon onClick={() => alert(`Action clicked for row ${rowIndex + 1}`)} />
  </div>
);

const Risk = () => {
  const [pageCount, setPageCount] = useState(10);
  const [showFilter, setShowFilter] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]); // Track multiple active buttons
  const [rowsContent, setRowsContent] = useState(users);
  const [activeTab, setActiveTab] = useState("Group trading");
  const [showDialog, setShowDialog] = useState();

  const [accounts, setAccounts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [accountType, setAccountType] = useState("Group trading");
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState("")
  const switchTabs = ["Group trading", "Challenge", "Funded"];
  const [showTableDialog, setShowTableDialog] = useState(false);


  console.log("WHAT IS THE FILTER", activeFilters)

  


  const cardRef = useRef(null);

  const handleClickOutside = (event) => {
    if (cardRef.current && !cardRef.current.contains(event.target)) {
      setShowFilter(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    if(activeTab === "Group trading"){
      setRowsContent(users)
    }else if(activeTab === "Challenge"){
      setRowsContent(accounts)
    }else if(activeTab === "Funded"){
      setRowsContent(funded)
    }
  }, [activeTab])

  useEffect(() => {
    fetchTradingAccounts();
  }, [currentPage, accountType, activeFilters]);

  const toggleFilter = (filter) => {
    setActiveFilters((prevFilters) =>
      prevFilters.includes(filter)
        ? prevFilters.filter((item) => item !== filter) // Remove if already active
        : [...prevFilters, filter] // Add if not active
    );
  };


  // Fetch statistics when the component mounts or when page changes
  // useEffect(() => {
  //   fetchStatistics(currentPage);
  // }, [currentPage]);

  // Handle page change
  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1; // React Paginate uses 0-based index
    setCurrentPage(selectedPage); // Update current page state
  };




  const token = localStorage.getItem("token")
  

  const fetchTradingAccounts = async () => {
    try {
      const params = { page: currentPage, limit: 10 };
      if (accountType) params.accountType = accountType;
      if (activeFilters.length > 0) params.status = activeFilters.join(",");

      const response = await axios.get(`${env.apiUrl}/api/account/trading-accounts`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAccounts(response.data.data);
      setTotalPages(response.data.totalPages);

      console.log("ACCOUNTS", response.data)

      // Dynamically set columns based on accountType
      if (accountType === "Group trading") {
        setColumns([
          { key: "groupID", label: "Group ID" },
          { key: "flagsCount", label: "Flags Count" },
          { key: "riskScore", label: "Risk Score" },
          { key: "status", label: "Status" },
        ]);
      } else if (accountType === "Challenge") {
        setColumns([
          { key: "user", label: "User" },
          { key: "startDate", label: "Start Date" },
          { key: "stage", label: "Stage" },
          { key: "status", label: "Status" },
        ]);
      } else if (accountType === "Funded") {
        setColumns([
          { key: "user", label: "User" },
          { key: "accountID", label: "Account ID" },
          { key: "status", label: "Status" },
          { key: "groupTrading", label: "Group Trading" },
        ]);
      }
    } catch (error) {
      setError("Error fetching trading accounts")
      console.error("Error fetching trading accounts:", error);
    }
  };



  const columns3 = [
    { key: "name", label: "Name" },
    { key: "accountID", label: "AccountID" },
    { key: "symbol", label: "Symbol" },
    { key: "ticket", label: "Ticket" },
    { key: "direction", label: "Direction" },
    { key: "volume", label: "Volume" },
    { key: "entry", label: "Entry" },
    { key: "exit", label: "Exit" },
  ];

  if (!accounts) {
    return <div>Loading...</div>;
  }

    // Render loading or error state
    if (error) {
      return <div>Error: {error}</div>;
    }
 

  return (
    <div className={classes.wrapper}>
      {/* <div className="d-flex align-items-center justify-content-center">
        <InputField
          className={classes.searchInput}
          search={true}
          placeholder="Search users"
          onChange={handleSearch}
        />
      </div> */}
      <div className="d-flex align-items-center justify-content-between mt-3">
        <div className="d-flex align-items-center gap-4">
          <h3>Risk</h3>
          <div className="d-flex align-items-center gap-3">
          <div
            className={`${classes.switcherContainer} d-flex align-items-center gap-0`}
          >
            {switchTabs.map((item, i) => (
              <div
                key={i}
                className={`${classes.switchButton} ${
                  accountType === item ? classes.activeButton : ""
                }`}
                onClick={() => setAccountType(item)}
                role="button"
              >
                {item}
              </div>
            ))}
          </div>
          {accountType === "Challenge" && <div className={`${classes.filterContainer}`}>
          <div className={`${classes.filterContainer} d-flex align-items-center gap-1`} onClick={() => setShowFilter(!showFilter)} role="button">
            <FilterIcon />
            Filter
            </div>
            {showFilter && <CommonCard className={`${classes.filterCard}`} ref={cardRef}>
            Filter by:
            <div className="d-flex align-items-center gap-2 mt-3">
            {["Failed", "Ongoing", "Passed"].map((filter) => (
              <button
                key={filter}
                onClick={() => toggleFilter(filter)}
                className={activeFilters.includes(filter) ? classes.activeButton : ""}
              >
                {filter}
              </button>
            ))}
            </div>
            </CommonCard>}
          </div>}

          </div>
          
        </div>
        {/* <CommonButton title="See past requests" onClick={() => {}} /> */}
      </div>

      

      <CommonCard className={`${classes.tableCard} mt-4`}>
        <Table data={accounts} renderAction={renderAction} dataType={accountType} groupClick={() => setShowDialog(true)} columns={columns} setShowDialog={(value) => setShowTableDialog(value)} showDialog={showTableDialog}/>
        <AlertDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        // centerCard={true}
        titleText="Breakdown"
        style={{left: `calc(50vw - 40vw)`}}
        showCloseIcon={true}
        cardClass={classes.breakdownWrapper}
      >
        <div className={classes.contentContainer}>
        <CommonCard className={``}>
        <Table data={groupData} renderAction={renderAction} dataType="Group" columns={columns3}/>
        </CommonCard>
        </div>
       
       
      </AlertDialog>
        <ReactPaginate
          previousLabel={<FaChevronLeft />} // React Icon for left arrow
          nextLabel={<FaChevronRight />} // React Icon for right arrow
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={1}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          previousLinkClassName={`page-link ${
            currentPage === 0 ? "disabled" : ""
          }`}
          nextLinkClassName={`page-link ${
            currentPage === totalPages - 1 ? "disabled" : ""
          }`}
          activeClassName={"active"}
        />
      </CommonCard>
    </div>
  );
};

export default Risk;
